export const nickNamePreFix = [
  'Happy',
  'Cheerful',
  'Kind',
  'Brave',
  'Bright',
  'Smart',
  'Calm',
  'Sunny',
  'Friendly',
  'Joyful',
  'Lively',
  'Helpful',
  'Honest',
  'Warm',
  'Gentle',
  'Strong',
  'Energetic'
];

export const nickNameFoodName = [
  // Fruits
  'Apple',
  'Pear',
  'Peach',
  'Nectarine',
  'Plum',
  'Cherry',
  'Apricot',
  'Grape',
  'Strawberry',
  'Watermelon',
  'Melon',
  'Banana',
  'Mango',
  'Papaya',
  'Guava',
  'Kiwi',
  'Lemon',
  'Lime',
  'Orange',
  'Mandarin',
  'Grapefruit',
  'Blueberry',
  'Raspberry',
  'Blackberry',
  // Vegetables & herbs
  'Tomato',
  'Cucumber',
  'Carrot',
  'Pumpkin',
  'Courgette',
  'Aubergine',
  'Onion',
  'Garlic',
  'Spinach',
  'Cabbage',
  'Kale',
  'Celery',
  'Parsley',
  'Basil',
  'Mint',
  'Lettuce',
  'Radish',
  'Beetroot',
  'Ginger',
  'Turnip',
  // Legumes, grains, nuts
  'Chickpea',
  'Lentil',
  'Pea',
  'Sesame',
  'Almond',
  'Hazelnut',
  'Walnut',
  'Pistachio',
  'Cashew',
  'Peanut',
  'Coconut',
  'Sunflower'
];

// Helper function to generate a random nickname
export const generateRandomNickname = () => {
  const randomPrefix = nickNamePreFix[Math.floor(Math.random() * nickNamePreFix.length)];
  const randomFood = nickNameFoodName[Math.floor(Math.random() * nickNameFoodName.length)];
  return randomPrefix + ' ' + randomFood;
};
